import { sys } from "@/Core/utils/system";
import { fetcher, useAPI, useAPIMutation } from "@/api/api";
import { IFRedPackConfig } from "@/api/apiRsp/IFRedPack";
import useSWR from "swr";

class SWRWalletKey {
    //切换法币充值
    public static get getRedrainConfig() {
        return `useGetRedrainConfig?${sys.token}`
    }
}
/**获取红包雨配置 */
export const useGetRedrainConfig = () => {
    const fetch = () => {
        // return new Promise<IFRedPackConfig>((resolve,reject)=>{
        //     setTimeout(()=>{
        //         resolve({
        //             playerPayCnt: 100,
        //             rechargeMin: 100,
        //             lastmodifyTime: Date.now(),
        //             redRainTime: 60,
        //             nexttime: Date.now() + 10 * 1000,
        //             nextendtime: Date.now() + 30 * 1000
        //         })
        //     },2 * 1000)
        // }).then((res:IFRedPackConfig)=>{
        //     return res;
        // })
        return new Promise<IFRedPackConfig>((resolve, reject) => {
            fetcher<IFRedPackConfig>({
                path: "api/HbyActivity/getHbyConfigList",
                type: "get",
            }, {}).then((res: IFRedPackConfig) => {
                console.log("11111111111111")
                console.log(res)
                res.lastmodifyTime = res.lastmodifyTime * 1000;
                res.nextendtime = res.nextendtime * 1000;
                res.nexttime = res.nexttime * 1000;
                res.isEnoughActivity = true;
                resolve(res)
            }).catch((e)=>{
                if(`${e?.errorCode}` === '10091') {
                    //钱不够
                    resolve(e?.data)
                } else if(`${e?.errorCode}` === '10099'){
                    reject(e)
                }else {
                    reject(e)
                }
            })
        })
    }
    return useSWR<IFRedPackConfig>(SWRWalletKey.getRedrainConfig, fetch, {
        dedupingInterval: 0,
    })
};

export const useGetRedrainConfigTrigger = () => {
    return useAPIMutation({
        path: "api/HbyActivity/getHbyConfigList",
        type: "get",
    })
}

export const useOpenRedpack = () => {
    return useAPIMutation({
        path: "api/HbyActivity/saveHbyReq",
        type: "get",
    })
}